import { injectable, inject } from 'inversify';
import { CommandHandler, createCommand } from '@/app/tracking/api';
import { XApiClient } from '@/app/tracking/xapi/tincan/client';
import { QuestionSuspendDataStore } from './question-suspend-data-state-store';
import { QuestionAnsweredStatementParams, createQuestionAnsweredStatement } from './question-answered-statement';
import { AnswerQuestionTrackingCommand, AnswerQuestionTrackingCommandPayload } from '../api';

@injectable()
export class XApiAnswerQuestionCommandHandler implements CommandHandler<AnswerQuestionTrackingCommand> {

  constructor(
    @inject(QuestionSuspendDataStore)
    private questionStore: QuestionSuspendDataStore,
    @inject(XApiClient)
    private client: XApiClient) {
  }

  public async execute(command: AnswerQuestionTrackingCommandPayload) {
    await this.questionStore.execute(createCommand<AnswerQuestionTrackingCommand>('answer-question', command));

    // TODO: factory
    const { question, meta } = command;
    const params: QuestionAnsweredStatementParams = {
      id: question.id,
      title: meta.title,
      type: meta.type
    };

    const statement = createQuestionAnsweredStatement(params);
    await this.client.sendStatement(statement);
  }
}
